import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ReportLayout from "examples/LayoutContainers/ReportLayout";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import URLs from "constants/urls";
import MonthlyOverView from "components/Forms/BusinessEntry/MonthEnd/monthlyOverView";
import MonthlyMISMain from "components/Accounts/MISReports/MonthlyMIS/monthlyMis";
import EmpProfitability from "components/Accounts/MISReports/EmployeeProfitability/empProfitability";
import MonthlyDSABusinessCard from "components/Accounts/MISReports/MonthlyBusiness/monthlyDsaBusiness";
import MonthlyBusinessByDsaCard from "components/Accounts/MISReports/MonthlyBusiness/monthlyBusinessDsa";
import ProductBusiness from "components/Accounts/MISReports/Reports/productBusiness";
import ProviderBusiness from "components/Accounts/MISReports/Reports/providerBusiness";
import InsuranceReportsheet from "components/Forms/BusinessEntry/Insurance/insuranceDashbrd";
import PipeLineReport from "components/Forms/BusinessEntry/PipeLine/pipeLine";
import ResponsiveButtonGroup from "./responnsiveTabs";
import ActualProfitAndLoss from "components/Accounts/MISReports/ActualP&L";
import DsaMaster from "components/Accounts/MISReports/DSAMasterReports/dsapost";
import PartialDisburementsReport from "components/Accounts/MISReports/Partialdisburements";
import IncompleteDisbursements from "components/Accounts/MISReports/IncompleteDisbursements/incompleteDisbursements"; // ✅ new import
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Height } from "@mui/icons-material";

const ReportsPanel = () => {
  const [activeButton, setActiveButton] = useState(0);

  const tabs = [
    {
      label: "Month-End Business",
      component: <MonthlyOverView url={URLs.monthEndUrl} />,
    },
    {
      label: "MIS Report",
      component: <MonthlyMISMain />,
    },
    {
      label: "Staff Profitability",
      component: <EmpProfitability />,
    },
    {
      label: "KH Business",
      component: <MonthlyBusinessByDsaCard />,
    },
    {
      label: "All DSA's Business",
      component: <MonthlyDSABusinessCard />,
    },
    {
      label: "Product Business",
      component: (
        <ProductBusiness
          productWiseBusinesByDateRange={URLs.alldsaproductwisereport}
          productWiseBusinessByProductId={URLs.khproductwisebifurcated}
          isItByDsa={false}
        />
      ),
    },
    // {
    //   label: "KH Product Business",
    //   component: (
    //     <ProductBusiness
    //       productWiseBusinesByDateRange={URLs.khproductwisereport}
    //       productWiseBusinessByProductId={URLs.khproductwisebifurcated}
    //       isItByDsa={true}
    //     />
    //   ),
    // },
    {
      label: "Provider Business",
      component: (
        <ProviderBusiness
          providerWiseBusinesByDateRange={URLs.alldsaproviderbusiness}
          providerWiseBusinessEntriesURL={URLs.providerWiseBusinessEntriesURL}
        />
      ),
    },
    // {
    //   label: "KH Provider Business",
    //   component: (
    //     <ProviderBusiness
    //       providerWiseBusinesByDateRange={URLs.khproviderwisebusiness}
    //       providerWiseBusinessEntriesURL={URLs.khproviderbusinessbifurcatedreport}
    //       isItByDsa={true}
    //     />
    //   ),
    // },
    {
      label: "Insurance Report",
      component: <InsuranceReportsheet />,
    },
    {
      label: "Pipeline Business",
      component: <PipeLineReport />,
    },
    {
      label: "Actual P & L",
      component: <ActualProfitAndLoss />,
    },
    {
      label: "Incomplete Disbursements", // ✅ new tab
      component: <IncompleteDisbursements />,
    },
    {
      label: "PartialDisburementsReport",
      component: <PartialDisburementsReport />,
    },
  ];

  const handleButtonChange = (index) => {
    setActiveButton(index);
  };

  return (
    <ReportLayout>
      <span style={{ display: "block", paddingTop: "0.7em" }}></span>
      <ResponsiveButtonGroup
        buttons={tabs}
        activeButton={activeButton}
        onChange={handleButtonChange}
        bgColor="#E59400"
        width="100%"
      />
      {tabs[activeButton]?.component}
    </ReportLayout>
  );
};

export default ReportsPanel;
